import { render, staticRenderFns } from "./byr.vue?vue&type=template&id=026aed86&scoped=true&"
import script from "./byr.vue?vue&type=script&lang=js&"
export * from "./byr.vue?vue&type=script&lang=js&"
import style0 from "./byr.vue?vue&type=style&index=0&id=026aed86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026aed86",
  null
  
)

export default component.exports